import { Currency } from '@search/filter-enums/enums/Currency';
import { NewBuildingFlat } from '@search/graphql-typings';
import { formatPrice } from '@search/helpers/src/formatPrice';

export const renderNewBuildingFlatStatus = (flat: NewBuildingFlat): string | undefined => {
    if (flat.isSoldOut) {
        return 'Проданы';
    }

    if (flat!.isSoon) {
        return 'Скоро в продаже';
    }

    if (flat!.isTemporaryNotOnSale) {
        return 'Временно не в продаже';
    }

    if (flat!.formatPriceRange) {
        return flat!.formatPriceRange;
    }

    if (flat.priceMin) {
        const format = formatPrice({
            value: flat.priceMin * 100,
            noFractional: true,
            inWords: true,
            displayCurrency: true,
            currency: Currency.RUB
        });

        return `от ${format}`;
    }

    if (! (flat!.formatPriceRange || flat.priceMin)) {
        return 'Уточняйте по телефону';
    }

    return undefined;
};
